import chineseStopWords from '../stopwords/chinese';
import japaneseStopWords from '../stopwords/japanese';
export const OPTIONS = {
    filterSubString: false,
    maxPhraseLength: 8,
    minFrequency: 1,
};
export const STOP_WORDS = {
    chinese: chineseStopWords,
    japanese: japaneseStopWords,
};
//# sourceMappingURL=constant.js.map